import React from "react";
import { Container } from "react-bootstrap";

export default function Shipping() {
  return (
    <Container className="py-5">
      <h2>Shipping Policy</h2>
      <p className="mt-3">
        TickTickGo is a <strong>digital service platform</strong> and does not ship
        any physical products. All our offerings are related to business
        service management, scheduling, and digital tools.
      </p>
      <p>
        As such, there are no shipping charges, timelines, or physical deliveries
        associated with our services.
      </p>
    </Container>
  );
}
